import * as ACTION_TYPES from '../types';

let initialState = {
  notificationList: [],
}

export default (state = initialState, action) => {
    switch (action.type) {

      case ACTION_TYPES.GET_NOTIFICATIONS:
        return {...state, notificationList: action.data };

      case ACTION_TYPES.REQUEST:
        return {...state, loading: true };

      case ACTION_TYPES.DONE:
        return {...state, loading: false };

      case ACTION_TYPES.RESET_NOTIFICATIONS:
        return {...state, notificationList: []};

      default:
        return state;
    }
  };